import React from 'react';
import { FirebaseContextProps } from 'config/interfaces';

const initial: FirebaseContextProps = {firebase: true}
export const FirebaseContext = React.createContext(initial);